(() => {
  const root = document.querySelector('[data-pr3d-root].pr3d-destination');
  if (!root || root.dataset.pr3dBooted === 'true') return;
  root.dataset.pr3dBooted = 'true';

  const overlay = root.querySelector('[data-pr3d-overlay]');
  const scroller = root.querySelector('[data-pr3d-scroll]');
  const stage = root.querySelector('[data-pr3d-stage]');
  const fallback = root.querySelector('[data-pr3d-fallback]');
  const loading = root.querySelector('[data-pr3d-loading]');
  const boot = root.querySelector('[data-pr3d-destination-boot]');
  const chapterEyebrow = root.querySelector('[data-pr3d-eyebrow]');
  const chapterTitle = root.querySelector('[data-pr3d-title]');
  const chapterBody = root.querySelector('[data-pr3d-body]');
  const chapterNumber = root.querySelector('[data-pr3d-number]');
  const sceneInstruction = root.querySelector('[data-pr3d-instruction]');
  const objectLabel = root.querySelector('[data-pr3d-object-label]');
  const objectLabelText = root.querySelector('[data-pr3d-object-label-text]');
  const inspectButtons = root.querySelector('[data-pr3d-inspect-buttons]');
  const dots = [...root.querySelectorAll('[data-pr3d-chapter]')];
  const nextButton = root.querySelector('[data-pr3d-next]');
  const skipButtons = [...root.querySelectorAll('[data-pr3d-skip]')];
  const shopButtons = [...root.querySelectorAll('[data-pr3d-shop]')];
  const configNode = root.querySelector('[data-pr3d-config]');

  let config = {};
  try { config = JSON.parse(configNode?.textContent || '{}'); } catch (_) {}
  if (!overlay || !scroller || !stage || !config.studioUrl) return;

  const finalCopy = root.querySelector('.pr3d-final p');
  if (finalCopy) finalCopy.textContent = 'Continue to the Hindi Hanuman Chalisa product page to choose your pack and order.';

  const chapters = [
    { at: 0, eyebrow: 'THE HANUMAN CHALISA GIFT SET', title: 'Devotion, beautifully experienced.', body: 'Nurturing Humanity.' },
    { at: .10 / 1.3, eyebrow: 'THOUGHTFULLY PRESENTED', title: 'A little box. A world within.', body: 'A moment to pause. A gift to keep.' },
    { at: .50 / 1.3, eyebrow: 'THE HANUMAN CHALISA GIFT SET', title: 'Every detail, with meaning.', body: 'One pocket-size hardcover. Two wallet devotional cards. One sticker sheet.' },
    { at: 1 / 1.3, eyebrow: 'SACHITRA EVAM BHAVARTH', title: 'Made to hold. Made to keep.', body: 'A hardcover companion for home, temple and travel.' },
    { at: 1.08 / 1.3, eyebrow: 'OPEN TO SOMETHING MEANINGFUL', title: 'Read. Understand. Feel.', body: 'Selected pages from the original Hindi edition.' },
    { at: 1.24 / 1.3, eyebrow: 'A DAILY RITUAL. A MEANINGFUL GIFT.', title: 'For you. For your people.', body: 'Continue with the Hindi Hanuman Chalisa in the PRADIPATVA store.' }
  ];

  const progress = { current: 0 };
  const selection = { current: '' };
  let activeChapter = -1;
  let started = false;
  let completed = false;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const currentUrl = new URL(location.href);
  const source = currentUrl.searchParams.get('from') || 'direct';
  const preservedVariantId = currentUrl.searchParams.get('variant') || '';

  try { sessionStorage.setItem('pr3d_opened_hanuman_hindi', '1'); } catch (_) {}
  try { sessionStorage.setItem('pr3d_cart_after_tracked', '0'); } catch (_) {}
  try { sessionStorage.removeItem('pr3d_completed_hanuman_hindi'); } catch (_) {}

  const push = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      pr3d: true,
      experience: 'hindi_hanuman_gift_set_v12',
      product_id: config.productId,
      product_handle: config.productHandle,
      variant_id: preservedVariantId || String(config.variantId || ''),
      entry_source: source,
      ...detail
    });
  };

  const productDestination = () => {
    const target = new URL(config.productUrl || '/products/hanuman-chalisa-hindi', location.origin);
    if (preservedVariantId) target.searchParams.set('variant', preservedVariantId);
    return `${target.pathname}${target.search}${target.hash}`;
  };

  const chapterIndexFor = (p) => {
    let index = 0;
    chapters.forEach((chapter, i) => { if (p >= chapter.at - .015) index = i; });
    return index;
  };

  const setChapter = (index) => {
    if (index === activeChapter) return;
    activeChapter = index;
    const chapter = chapters[index];
    chapterEyebrow.textContent = chapter.eyebrow;
    chapterTitle.textContent = chapter.title;
    chapterBody.textContent = chapter.body;
    chapterNumber.textContent = `0${index + 1} / 06`;
    sceneInstruction.textContent = index === 2 ? 'TAP AN ITEM TO EXPLORE' : index === 3 ? 'DRAG GENTLY TO EXPLORE' : index === 4 ? 'SCROLL TO TURN THE PAGES' : 'HINDI HANUMAN CHALISA';
    dots.forEach((dot, i) => dot.toggleAttribute('aria-current', i === index));
    inspectButtons.hidden = index !== 2;
    overlay.dataset.pr3dChapter = String(index + 1);
    if (index === 5 && !completed) {
      completed = true;
      try { sessionStorage.setItem('pr3d_completed_hanuman_hindi', '1'); } catch (_) {}
      push('3d_experience_completed', { chapter: 6 });
    }
  };

  const syncProgress = () => {
    const max = Math.max(1, scroller.scrollHeight - scroller.clientHeight);
    progress.current = Math.min(1, Math.max(0, scroller.scrollTop / max));
    setChapter(chapterIndexFor(progress.current));
  };

  const jump = (at) => {
    const max = Math.max(1, scroller.scrollHeight - scroller.clientHeight);
    scroller.scrollTo({ top: max * at, behavior: reducedMotion ? 'auto' : 'smooth' });
  };

  const revealExperience = () => {
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pr3d-open');
    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
    scroller.scrollTop = 0;
    syncProgress();
    push('3d_experience_opened');
  };

  const clearBoot = () => {
    if (!boot) return;
    boot.style.opacity = '0';
    boot.style.transition = 'opacity .18s ease';
    setTimeout(() => boot.remove(), 220);
  };

  const showFallback = (reason = 'fallback') => {
    loading.hidden = true;
    fallback.hidden = false;
    stage.hidden = true;
    clearBoot();
    root.dataset.pr3dFallback = reason;
    root.querySelector('[data-pr3d-fallback-status]').textContent = reason === 'reduced_motion' ? 'Reduced-motion preview' : 'Interactive 3D is unavailable on this device. Product photography is shown.';
    if (!started) { started = true; push('3d_experience_started', { mode: reason }); }
  };

  // Skip is an explicit commerce exit: always continue to this experience's product page.
  const skipToProduct = () => {
    if (!completed) push('3d_experience_skipped', { chapter: activeChapter + 1 });
    location.assign(productDestination());
  };

  // Escape remains a generic exit and can return to the previous same-store page.
  const returnToSource = () => {
    const ref = document.referrer;
    try {
      const refUrl = ref ? new URL(ref) : null;
      if (history.length > 1 && refUrl && refUrl.origin === location.origin && refUrl.pathname !== location.pathname) {
        history.back();
        return;
      }
    } catch (_) {}
    location.assign(productDestination());
  };

  const shop = () => {
    push('3d_experience_shop_clicked', { chapter: activeChapter + 1, completed });
    location.assign(productDestination());
  };

  revealExperience();

  (async () => {
    if (reducedMotion) { showFallback('reduced_motion'); return; }
    try {
      for (const [name, url] of Object.entries(config.assets || {})) {
        if (name.startsWith('reference-') || !url) continue;
        const hint = document.createElement('link');
        hint.rel = 'preload';
        hint.as = 'image';
        hint.crossOrigin = 'anonymous';
        hint.href = url;
        document.head.appendChild(hint);
      }
      const [T, studio] = await Promise.all([import(config.threeUrl), import(config.studioUrl)]);
      await studio.createStudio(T, stage, progress,
        () => {
          loading.hidden = true;
          fallback.hidden = true;
          stage.hidden = false;
          clearBoot();
          if (!started) { started = true; push('3d_experience_started', { mode: 'webgl' }); }
        },
        (label) => {
          selection.current = label || '';
          objectLabelText.textContent = selection.current;
          objectLabel.hidden = !selection.current;
        },
        () => showFallback('webgl_unavailable'), selection, config.assets || {});
    } catch (error) {
      console.error('PRADIPATVA 3D failed to start', error);
      showFallback('load_failed');
    }
  })();

  skipButtons.forEach((button) => button.addEventListener('click', skipToProduct));
  shopButtons.forEach((button) => button.addEventListener('click', shop));
  scroller.addEventListener('scroll', syncProgress, { passive: true });
  dots.forEach((dot, index) => dot.addEventListener('click', () => jump(chapters[index].at)));
  nextButton?.addEventListener('click', () => activeChapter >= chapters.length - 1 ? shop() : jump(chapters[Math.min(activeChapter + 1, chapters.length - 1)].at));
  root.querySelector('[data-pr3d-object-close]')?.addEventListener('click', () => { selection.current = ''; objectLabel.hidden = true; });
  root.querySelectorAll('[data-pr3d-inspect]').forEach((button) => button.addEventListener('click', () => {
    selection.current = button.dataset.pr3dInspect || '';
    objectLabelText.textContent = selection.current;
    objectLabel.hidden = false;
    jump(.83 / 1.3);
  }));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') returnToSource(); });
})();
